// extracted by mini-css-extract-plugin
export default {"date":"CommentsDateTime_date__8EakZ","time":"CommentsDateTime_time__kuo7c"};